module.exports = __webpack_public_path__ + "media/common/images/badges/gray/nakrmeny_mozek-a11dd0c88e811ca1e74c74c804a8b1fb.svg";